<!-- Is Authenticated: {{ isAuthenticated }}
<button id="loginBtn" (click)="login()">Login</button>
<button id="logoutBtn" (click)="logout()">Logout</button>

<button [routerLink]="['/client/edit/1']">Aller vers Client 1</button>
<button [routerLink]="['/clients']">Aller vers Clients</button>
 -->


<!-- <div *ngIf="authentificationService.isAuthenticated"> -->
<div>
    <router-outlet></router-outlet>
</div>
<app-alert-modal-wrapper></app-alert-modal-wrapper>
<app-toast-container></app-toast-container>

<!-- Pas de | translate ici : les traductions viennent de l'API injoignable -->
@if (authentificationService.bootError(); as error) {
    <div class="fixed inset-0 z-[10000] flex items-center justify-center bg-gray-100 p-4">
        <div class="bg-white shadow-lg rounded-lg p-8 max-w-md w-full text-center">
            <h1 class="text-2xl font-bold text-red-600 mb-4">
                {{ error.kind === 'unreachable' ? 'API unreachable' : 'API error' }}
            </h1>
            @if (error.kind === 'unreachable') {
                <p class="text-gray-700 mb-2">The application cannot reach the server at</p>
                <p class="font-mono text-sm text-gray-900 mb-6 break-all">{{ apiUrl }}</p>
                <p class="text-gray-700 mb-6">Start the API, then retry.</p>
            } @else {
                <p class="text-gray-700 mb-6">
                    The server answered with status {{ error.status }} while loading the account.
                </p>
            }
            <button (click)="authentificationService.retryBoot()"
                [disabled]="authentificationService.bootInProgress()"
                class="bg-blue-500 hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-semibold py-2 px-4 rounded transition duration-200">
                {{ authentificationService.bootInProgress() ? 'Retrying...' : 'Retry' }}
            </button>
        </div>
    </div>
}